module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/position-fbd1e8221d5f2ae3ce78a2a8014d22a1.svg";